import { useState } from "react";
import { DEFAULT_PAGE_SIZE } from "./constants";

const usePaginate = (props?: { page?: number; size?: number }) => {
  const [currentPage, setCurrentPage] = useState(props?.page ?? 0);
  const [pageSize, setPageSize] = useState(props?.size ?? DEFAULT_PAGE_SIZE);
  const resetPage = () => setCurrentPage(0);

  const updatePageSize = (v: number) => {
    setPageSize(v);
    resetPage();
  };

  return {
    page: currentPage,
    setPage: setCurrentPage,
    pageSize,
    updatePageSize,
    resetPage,
  };
};

export default usePaginate;
